import { render, staticRenderFns } from "./poicategories.vue?vue&type=template&id=5cfc1c96&"
import script from "./poicategories.vue.js?vue&type=script&lang=js&"
export * from "./poicategories.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports